var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeKhamDoan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#616BAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13979_182076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.502 18.8237C24.9269 18.8237 26.8927 16.8485 26.8927 14.4119C26.8927 11.9753 24.9269 10 22.502 10C20.0771 10 18.1113 11.9753 18.1113 14.4119C18.1113 16.8485 20.0771 18.8237 22.502 18.8237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7635 19.4136C24.9125 20.1326 23.8704 20.4503 22.5018 20.4503C21.1332 20.4503 20.2127 20.1396 19.2262 19.3997C16.1555 19.9616 15.1064 22.9913 15.1064 25.3473V26.3281C15.1064 27.2251 15.5545 28.0698 16.3083 28.555C16.5411 28.7051 16.812 28.8552 17.1316 29.0018C17.3435 31.7941 19.6708 34 22.5053 34C25.3363 34 27.6671 31.7941 27.879 28.9983C28.1812 28.8586 28.4452 28.7155 28.6675 28.5724C29.4352 28.0838 29.9006 27.2391 29.9006 26.3246V25.3438C29.8972 23.1763 28.9523 20.0244 25.7635 19.4136ZM22.5018 33.0646C20.0459 33.0646 18.0451 31.0576 18.0451 28.5864C18.0451 26.1152 20.0425 24.1082 22.5018 24.1082C24.9577 24.1082 26.9585 26.1152 26.9585 28.5864C26.9585 31.0576 24.9577 33.0646 22.5018 33.0646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3526 16.6841C33.154 16.6841 34.6143 15.2167 34.6143 13.4066C34.6143 11.5965 33.154 10.1292 31.3526 10.1292C29.5512 10.1292 28.0908 11.5965 28.0908 13.4066C28.0908 15.2167 29.5512 16.6841 31.3526 16.6841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7778 17.1204C33.1456 17.6545 32.371 17.8883 31.3532 17.8883C30.3354 17.8883 29.6546 17.6579 28.9216 17.11C27.9942 17.281 27.3133 17.7522 26.834 18.3735C28.2408 18.8482 29.3732 19.8011 30.1374 21.1693C30.919 22.5655 31.1239 24.0314 31.1621 24.9634C31.2247 24.9634 31.2907 24.9634 31.3532 24.9634C33.7396 24.9634 35.1394 24.4293 35.9314 23.9267C36.5011 23.5637 36.8485 22.9354 36.8485 22.2583V21.5288C36.8485 19.9162 36.1468 17.5742 33.7778 17.1204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6475 16.6841C15.4489 16.6841 16.9092 15.2167 16.9092 13.4066C16.9092 11.5965 15.4489 10.1292 13.6475 10.1292C11.8461 10.1292 10.3857 11.5965 10.3857 13.4066C10.3857 15.2167 11.8461 16.6841 13.6475 16.6841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06938 23.9267C9.86137 24.4293 11.2612 24.9634 13.6476 24.9634C13.7136 24.9634 13.7761 24.9634 13.8387 24.9634C13.8804 24.0314 14.0853 22.5689 14.8634 21.1693C15.6276 19.8011 16.76 18.8482 18.1668 18.3735C17.6875 17.7522 17.0066 17.281 16.0792 17.11C15.3462 17.6579 14.6619 17.8883 13.6476 17.8883C12.6299 17.8883 11.8552 17.6545 11.223 17.1204C8.85402 17.5742 8.15234 19.9162 8.15234 21.5288V22.2583C8.15234 22.9354 8.49971 23.5637 9.06938 23.9267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7282 28.1187H22.9671V26.349C22.9671 26.0907 22.7587 25.8813 22.5016 25.8813C22.2446 25.8813 22.0362 26.0907 22.0362 26.349V28.1187H20.275C20.018 28.1187 19.8096 28.3281 19.8096 28.5864C19.8096 28.8447 20.018 29.0541 20.275 29.0541H22.0362V30.8237C22.0362 31.082 22.2446 31.2914 22.5016 31.2914C22.7587 31.2914 22.9671 31.082 22.9671 30.8237V29.0541H24.7282C24.9853 29.0541 25.1937 28.8447 25.1937 28.5864C25.1937 28.3281 24.9853 28.1187 24.7282 28.1187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13979_182076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6957,
    height: 24,
    fill: "white",
    transform: "translate(8.15234 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeKhamDoan);
export default __webpack_public_path__ + "static/media/PhanHeKhamDoan.e5c575f1.svg";
export { ForwardRef as ReactComponent };